export interface TagColor {
  bg: string
  text: string
  border: string
  darkBg: string
  darkText: string
  darkBorder: string
}

export const TAG_COLORS: TagColor[] = [
  { bg: 'bg-primary-100', text: 'text-primary-600', border: 'border-primary-300', darkBg: 'dark:bg-blue-900', darkText: 'dark:text-blue-200', darkBorder: 'dark:border-blue-700' },
  { bg: 'bg-green-100', text: 'text-green-800', border: 'border-green-300', darkBg: 'dark:bg-green-900', darkText: 'dark:text-green-200', darkBorder: 'dark:border-green-700' },
  { bg: 'bg-amber-100', text: 'text-amber-800', border: 'border-amber-300', darkBg: 'dark:bg-amber-900', darkText: 'dark:text-amber-200', darkBorder: 'dark:border-amber-700' },
  { bg: 'bg-purple-100', text: 'text-purple-800', border: 'border-purple-300', darkBg: 'dark:bg-purple-900', darkText: 'dark:text-purple-200', darkBorder: 'dark:border-purple-700' },
  { bg: 'bg-cyan-100', text: 'text-cyan-800', border: 'border-cyan-300', darkBg: 'dark:bg-cyan-900', darkText: 'dark:text-cyan-200', darkBorder: 'dark:border-cyan-700' },
  { bg: 'bg-red-100', text: 'text-red-800', border: 'border-red-300', darkBg: 'dark:bg-red-900', darkText: 'dark:text-red-200', darkBorder: 'dark:border-red-700' },
]

export function getColorForIndex(index: number): TagColor {
  return TAG_COLORS[index % TAG_COLORS.length]
}
